"use strict";

//	Kilopix

import * as kpc from "../../@kilopix/core.module";
import * as kpm from "../../@kilopix/methods.module";
import * as kpu from "../../@kilopix/utils.module";

//	Modules

import { AppInterface } from "../app.interface";

//	Dom selectors

const header = document.getElementById( "header" );
const article = document.getElementById( "article" );
const image = document.querySelector( "#article .figure" );
const text = document.querySelector( "#article .text" );

//	Article

export class Article {
	static scroll() {
		if ( !article ) {
			return;
		}

		let triggerStart = header.offsetHeight,
			perc = AppInterface.scrollTop / ( article.offsetTop - triggerStart ),
			perc1 = ( article.offsetTop + text.offsetHeight ) - AppInterface.scrollTop;

		if ( perc > 1 ) {
			kpm.addClass( image, "sticky" );
		} else {
			kpm.removeClass( image, "sticky" );
		}
		
		if ( perc1 < window.innerHeight ) {
			kpm.addClass( image, "push-out" );
		} else {
			kpm.removeClass( image, "push-out" );
		}
	}
}